import styled, { css } from 'styled-components'

import Icon from '@/ui/Icon'
import Text from '@/ui/Text'
import FlexRow from '@/ui/FlexRow'

export const SelectFormWrapper = styled.div`
  width: 250px;
`

export const SearchIcon = styled(Icon).attrs({
  name: 'icon-search',
})`
  &&& {
    margin-right: 0.5em;
    color: #012d3e;
    opacity: 0.4;
  }
`

export const Search = styled.input.attrs({ autoFocus: false })`
  &&&& {
    border: 0 !important;
    outline: 0 !important;
    padding: 0 !important;
    font-weight: 300 !important;
    font-size: 14px !important;
    width: 100% !important;

    &,
    ::placeholder {
      color: #4d6c78 !important;
    }
  }
`

export const SelectOptionsWrapper = styled.div`
  overflow: auto;
  max-height: 265px;
  font-weight: 300;
`

export const SelectOption = styled(({ active, ...rest }) => (
  <FlexRow {...rest} />
)).attrs({
  noMargin: true,
  className: 'select-option',
})`
  ${({ theme, active, hovered }) => css`
    border-radius: 3px;
    padding: 10px;
    cursor: pointer;
    background: ${active || hovered ? theme.colors.lightGrey : 'none'};

    &,
    span {
      font-weight: ${active ? 400 : 300};
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
    }
  `}
`

export const NoResults = styled(Text.Span).attrs({
  light: true,
  grey: true,
})`
  display: block;
  padding: 10px;
`
